module.exports = __webpack_public_path__ + "img/default4.860c5b68.png";